import { yupResolver } from '@hookform/resolvers/yup'
import { t } from 'i18next'
import { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import { IoIosArrowBack } from 'react-icons/io'

import { Button } from '../components/Button'
import { IconSelectorList } from '../components/IconSelectorList'
import { Input } from '../components/Input'
import { handleError } from '../helpers/handleError.ts'
import { urlValidation } from '../helpers/validationSchema.ts'
import { iconsEntriesMock } from '../mock/iconsEntriesMock.tsx'
import { createSocialMedia, getSocialMedia } from '../services/socialMedia.ts'
import { formatIconName } from '../utils/formatIconName.ts'
import { ModalWrapper } from './ModalWrapper.tsx'
import { toast } from 'react-toastify'

export const AddIconsModal = ({
  onClose,
  showModal,
  setShowModal,
  setSocialMediaIcons,
}: ModalProps) => {
  const [selectedIconName, setSelectedIconName] = useState<string | null>(null)
  const [searchQuery, setSearchQuery] = useState<string>('')

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(urlValidation),
  })

  const handleSelect = (iconName: string) => {
    setSelectedIconName(iconName)
  }

  const onSubmit = async (data: { link: string }) => {
    try {
      const reqData = {
        link: data.link,
        enabled: true,
        name: selectedIconName ?? '',
        icon: selectedIconName ?? '',
      }
      await createSocialMedia(reqData).then(() => {
        toast.success(t('iconCreateSuccess'))
        setShowModal(false)
        getSocialMedia().then((res) => {
          setSocialMediaIcons(res)
          setSelectedIconName(null)
          reset()
          setSearchQuery('')
        })
      })
    } catch (error) {
      handleError(error)
    }
  }

  const selectedIcon = iconsEntriesMock.find(
    (icon) => icon.name === selectedIconName,
  )

  useEffect(() => {
    if (!showModal) {
      setSelectedIconName(null)
      reset()
      setSearchQuery('')
    }
  }, [showModal, reset])

  return (
    <ModalWrapper onClose={onClose} showModal={showModal}>
      <div className="flex max-h-[600px] flex-col p-4">
        {!selectedIconName ? (
          <>
            <h1 className="mb-5 text-center text-sm font-medium">
              {t('addIcon')}
            </h1>

            <Input
              type="text"
              placeholder="Search"
              className="mb-8 text-sm"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
            <div className="overflow-auto">
              <IconSelectorList
                onSelect={handleSelect}
                searchQuery={searchQuery}
              />
            </div>
          </>
        ) : (
          <>
            <h1 className="mb-5 text-center text-sm font-medium">
              {/* {formatIconName(selectedIconName, t('addIcon'))} */}
              {t('addIconNameIcon', { iconname: selectedIconName })}
            </h1>

            <form className="flex flex-col" onSubmit={handleSubmit(onSubmit)}>
              <Input
                variant={errors.link ? 'danger' : 'primary'}
                type="text"
                placeholder={t('addIconUrl', { iconname: selectedIconName })}
                className="mb-3 text-sm placeholder:text-textSecondary"
                {...register('link')}
                helperText={errors.link ? errors.link.message : undefined}
              />

              <span className="mb-3 text-xs text-textSecondary">
                {`Example: ${selectedIcon?.exampleUrl}`}
              </span>

              <Button
                text={t('addToProfile')}
                type="submit"
                className="text-white"
              />
            </form>

            <div className="flex items-center justify-center">
              <IoIosArrowBack
                className="absolute left-4 top-[18px] cursor-pointer hover:scale-125"
                onClick={() => setSelectedIconName(null)}
              />
            </div>
          </>
        )}
      </div>
    </ModalWrapper>
  )
}
